const doc = [({"da":({"activerecord":({"models":({"photo_session_group_contact_token":({})}), "attributes":({"photo_session_group_contact_token":({"token":"Kode"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;